import { RoomApiRoomCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useRoomCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: RoomApiRoomCreateRequest, config) =>
      appApiClient.roomApi.roomCreate(req, config),
  });
